import { render, staticRenderFns } from "./m-lightbox-template-card.vue?vue&type=template&id=09cf9c33&scoped=true&"
import script from "./m-lightbox-template-card.vue?vue&type=script&lang=js&"
export * from "./m-lightbox-template-card.vue?vue&type=script&lang=js&"
import style0 from "./m-lightbox-template-card.vue?vue&type=style&index=0&id=09cf9c33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf9c33",
  null
  
)

export default component.exports